export const seniorBusinessPlanningResume = `
【職務概要】
経営企画として15年以上の実務経験を有し、中期経営計画の立案から予実管理、M&A戦略、投資判断に至るまで、幅広い業務領域に精通しています。特に海外事業の管理体制構築と業績向上施策の企画立案が得意領域です。

事業会社での経験を通じて、全社視点でのプロセス構築と改善、各部門との連携によるプロジェクト推進力を培ってまいりました。近年は製造業における海外拠点（米州、アジア圏）の事業管理・収益構造改革に注力し、業績向上と体制強化に取り組んでいます。IRや経営レポーティングにおいても専門性を発揮し、DX推進や内部統制の強化など、経営基盤の整備にも貢献してまいりました。経営データの可視化や分析における最新技術の活用にも積極的に取り組んでおります。

【職務経歴】
・株式会社Algomatic産業（製造業、従業員1,500名、海外子会社6社を有する精密機器メーカー）
　○就業期間：2016年4月〜現在
　○職務内容：海外事業管理部 部長
　　- 米国、中国、タイの3か国に展開する海外子会社の業績管理体制の構築と運用
　　- 各拠点の月次・四半期業績レビューの実施、経営層への報告体制の整備
　　- 海外子会社の事業計画策定支援と四半期ごとの進捗確認、課題抽出
　　- 海外拠点における設備投資計画の審査と意思決定プロセスの改革
　　- 本社と海外子会社間の業務連携体制の再構築（レポートラインの整理）
　○具体的な成果：
　　- 北米子会社の収益構造改革を主導し、営業利益率を3年間で5.2%から9.8%に改善
　　- 海外拠点の投資判断基準を明確化し、不採算投資を3件回避（約4億円相当）
　　- グループ共通の経営管理指標（KPI）を導入し、経営判断の迅速化に貢献
　　- 管理会計データの可視化システムを構築し、経営層の意思決定スピードを30%向上
　○使用した技術・ツール：
　　- Tableau、PowerBI等のBIツールを活用した経営ダッシュボードの構築
　　- SAP、Oracle等の基幹システムとの連携による統合データベースの整備
　○身につけたスキル：
　　- グローバル経営管理の実践的ノウハウ、多国籍チームのマネジメント
　　- 事業構造分析と収益改善策の立案・実行力

・株式会社Algomaticソリューションズ（情報通信業、従業員800名、SaaS事業を展開）
　○就業期間：2011年10月〜2016年3月
　○職務内容：経営企画部 グループマネージャー
　　- 中期経営計画の立案と年度方針への落とし込み、業界動向分析
　　- 新規事業開発プロジェクトのPMO（Project Management Office）運営
　　- 取締役会資料の作成と経営会議の運営事務局
　　- 投資案件の経済性評価と意思決定支援
　　- 組織再編・M&A案件の事業評価と推進
　○具体的な成果：
　　- クラウド事業への転換戦略を立案し、サブスクリプション型ビジネスへの移行を推進
　　- 新規事業開発プロセスを確立し、サービス開発期間を平均40%短縮
　　- 2件のM&A（買収総額30億円）の事業DD（デューデリジェンス）と統合計画を主導
　　- 全社的な予算管理プロセスを再構築し、予実管理の精度を向上
　○使用した技術・ツール：
　　- Microsoft 365、Salesforce等のクラウドツールを活用した経営管理システム
　　- プロジェクト管理ツール（Jira、Asana等）によるPMO運営
　○身につけたスキル：
　　- IT業界特有の事業モデル分析、成長戦略立案スキル
　　- M&A・PMIのプロセス理解と実践経験

・株式会社Algomaticテクノロジー（電機メーカー、従業員2,200名）
　○就業期間：2008年4月〜2011年9月
　○職務内容：経理財務部 主任
　　- 経営管理指標の設定と月次分析
　　- 年度予算策定と予実管理
　　- 資金計画の策定と実行管理
　　- 経営会議向け財務報告資料の作成
　○具体的な成果：
　　- 経営判断に必要な財務データの可視化と分析フレームワークを確立
　　- 事業部制導入に伴う予算管理体系の再構築を担当
　　- キャッシュ・コンバージョン・サイクルの改善施策を立案・実行（15日短縮）
　○使用した技術・ツール：
　　- ERP、財務会計システム、管理会計システム
　○身につけたスキル：
　　- 経営数値の分析・解釈と意思決定への活用
　　- 事業採算性評価の手法と実践

【受賞・表彰歴】
・2022年 株式会社Algomatic産業 年間MVP（海外子会社の業績V字回復に貢献）
・2020年 株式会社Algomatic産業 社長賞（経営管理システム刷新プロジェクトの成功）
・2016年 株式会社Algomaticソリューションズ 優秀プロジェクト賞（クラウド戦略立案チーム）
・2015年 日本CFO協会主催 ベスト・プラクティス・アワード ファイナリスト（経営管理高度化事例）

【資格】
・中小企業診断士（2014年3月取得）
・米国公認会計士（USCPA）（2012年5月取得）
・プロジェクトマネジメントプロフェッショナル（PMP）（2013年10月取得）
・MBA（グロービス経営大学院）（2011年3月修了）
・ITストラテジスト（2016年12月取得）
・TOEIC 870点（2021年7月）

【マネジメント経験】
・株式会社Algomatic産業 海外事業管理部（14名体制）の部長として組織マネジメント（2018年4月〜現在）
・経営戦略の策定・実行を通じた部門横断プロジェクトのリーダーシップ経験多数
　○海外子会社統合経営管理システム導入プロジェクト（メンバー20名、期間18ヶ月）
　○経営効率化プロジェクト（メンバー12名、期間12ヶ月、コスト削減額年間3.5億円）
・若手人材の育成プログラムを構築し、部門内で実施（3年で8名を次世代リーダーに育成）
・社内研修講師（事業計画策定、投資判断基準等のテーマで年4回実施）

【語学力】
・英語：ビジネスレベル（TOEIC 870点）
　○海外子会社とのテレカンファレンス、事業レビュー会議を英語で主導
　○英文での経営資料作成、海外投資家向けプレゼンテーション経験あり
・中国語：日常会話レベル（HSK 4級相当）
　○中国拠点訪問時の簡単なコミュニケーション、挨拶程度
` as const;
